<template>
    <el-row>
        <el-col>
            <div class="main-box">
                <div class="nav-box flex-row f-justify-between">
                    <div class="logo-box flex-row">
                        <img class="logo-box-img" src="../static/logo-title.png" alt="">
                        <!-- <img class="logo-box-text hidden-md-and-down" src="../static/logo-text.png" alt=""> -->
                    </div>
                    <div class="menu-box flex-row f-justify-between hidden-sm-and-down">
                        <div v-for="(item, index) in getNavBarList" :key="'menu' + index" @click="handleSelect(item, index)"
                            class="menu-box-item flex-column f-align-center "
                            :class="activeIndex == index ? 'menu-box-item-acvited animate__animated animate__fadeIn' : ''">
                            {{  userInfos.role==0?item.name:item.name1 }}</div>
                    </div>
                    <div class="user-box flex-row f-align-center">
                        <el-image v-if="userInfos.avatar" class="user-box-img" :src="userInfos.avatar"
                            fit="contain"></el-image>
                        <span class="user-box-text user-box-text2">{{ userInfos.userName }}</span>
                        <span class="user-box-text">,欢迎回来</span>
                        <span @click="logoutHandle" class="user-box-logout">退出登录</span>
                        <i class="el-icon-s-fold user-box-menu  hidden-md-and-up animate__animated animate__fadeIn"
                            @click="showDraw"></i>
                    </div>
                </div>


                <el-drawer title="简易读教育" :visible.sync="drawer" :direction="direction" size="60%" :append-to-body="true"
                    :modal-append-to-body="false">
                    <div class="draw-menu-box flex-column f-justify-between ">
                        <div v-for="(item, index) in getNavBarList" :key="'menu' + index" @click="handleSelect(item, index)"
                            class="draw-menu-box-item flex-column f-align-center "
                            :class="activeIndex == index ? 'draw-menu-box-acvited animate__animated animate__fadeIn' : ''">
                            {{ userInfos.role==0?item.name:item.name1 }}</div>
                    </div>
                </el-drawer>
            </div>
        </el-col>
    </el-row>
</template>


<script>

import { mapState, mapMutations } from 'vuex';
import toolsUtils from '../common/toolsUtils';

export default {
    data() {
        return {
            navBarList: [
                {
                    id: 1,
                    name: "学员首页",
                    name1: "教练首页",
                    routerPath: "home",
                    routerPath1: "home",
                    queryParams: "",
                    role:[0,1]
                },
                {
                    id: 2,
                    name: "21天抗遗忘",
                    name1: "21天抗遗忘",
                    routerPath: "day_practice",
                    routerPath1: "day_practice",
                    queryParams: "",
                    role:[0,1]
                },
                {
                    id: 3,
                    name: "词汇量测试",
                    name1: "词汇量测试",
                    routerPath: "vocabulary_test",
                    routerPath1: "vocabulary_test",
                    queryParams: "",
                    role:[0,1]
                },
                // {
                //     id: 4,
                //     name: "AI口语练习",
                //     routerPath: "",
                //     queryParams: ""
                // },
                {
                    id: 5,
                    name: "优秀学员",
                    name1: "优秀学员",
                    routerPath: "excellent_student",
                    routerPath1: "excellent_student",
                    queryParams: "",
                    role:[0,1]
                },
                {
                    id: 6,
                    name: "我的收藏",
                    name1: "我的收藏",
                    routerPath: "collection",
                    routerPath1: "collection",
                    queryParams: "",
                    role:[0]
                },
                {
                    id: 7,
                    name: "关于我们",
                    name1: "关于我们",
                    routerPath: "abou_us",
                    routerPath1: "abou_us",
                    queryParams: "",
                    role:[0,1]
                },
            ],
            activeIndex: 0,
            drawer: false,
            direction: 'ltr',
        };
    },
    computed: {
        ...mapState([
            'userInfos',
            'navBarActivedIndex'
        ]),
        getNavBarList(){
            let tmp = this.navBarList.filter(item=>{
                if(item.role.indexOf(Number(this.userInfos.role)) > -1){
                    return true;
                }else {
                    return false;
                }
            })
            console.log(tmp)
            return tmp;
        }
    },
    created() {


    },
    methods: {
        ...mapMutations(["logoutUser", "changeStoreNavBarIndex"]),
        handleSelect(item, index) {
            // toolsUtils.setStorageSync("navBarActivedIndex", index);
            // this.changeStoreNavBarIndex();
            // this.activeIndex = this.navBarActivedIndex;
            this.$emit("changeTab", index, item)
        },
        showDraw() {
            this.drawer = true;
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        },
        logoutHandle() {

            this.logoutUser();
            this.$router.replace({
                path: "/login"
            })
        }
    },
    watch: {
        $route: {
            handler: function (route) {
                //获取当前路由的对应的 navbar下标
                let routerPath = route.name ? route.name : 'home';
                this.navBarList.find((item, index) => {

                    if (this.userInfos.role == 0) {
                        if (item.routerPath == routerPath) {
                            toolsUtils.setStorageSync("navBarActivedIndex", index);
                            console.log("index: ", index)
                        }
                    }else if(this.userInfos.role == 1){
                        if (item.routerPath1 == routerPath) {
                            toolsUtils.setStorageSync("navBarActivedIndex", index);
                            console.log("index: ", index)
                        }
                    }
                })
                this.changeStoreNavBarIndex();
                this.activeIndex = this.navBarActivedIndex;
            },
            immediate: true
        }
    }

};
</script>

<style lang="scss" scoped>
.el-menu.el-menu--horizontal {
    border-bottom: none;
}

.main-box {
    height: 80px;
    background: #fff;
}

.el-menu {
    display: flex;
    justify-content: flex-end;
}

.nav-box {
    height: 80px;

    .logo-box {
        .logo-box-img {
            margin-top: 17px;
            width: 145px;
            height: 65px;
        }

        .logo-box-text {
            width: 162px;
            height: 53px;
            margin-top: 22px;
            margin-left: 7px;
        }
    }

    .menu-box {
        margin-top: 39px;
        margin-left: 30px;
        margin-right: 57px;
        width: 748px;
        height: 35px;

        .menu-box-item {
            position: relative;
            font-family: 思源黑体;
            font-size: 18px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0em;
            color: #333;

            &:hover {
                cursor: pointer;
            }
        }

        .menu-box-item-acvited {
            color: #0AA26B;

            &::before {
                content: "";
                display: inline-block;
                position: absolute;
                width: 59px;
                height: 4px;
                background: #0AA26B;
                top: 30px;
            }
        }
    }

    .user-box {
        margin-top: 22px;

        .user-box-img {

            width: 24px;
            height: 24px;
            border-radius: 12px;
        }

        .user-box-text {
            max-width: 60px;
            height: 18px;
            font-family: 思源黑体;
            font-size: 12px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0em;
            color: #333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .user-box-text2 {
            margin-left: 11px;
        }

        .user-box-logout {
            width: 48px;
            margin-left: 24px;
            font-family: 思源黑体;
            font-size: 12px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0em;
            color: #0AA26B;

            &:hover {
                cursor: pointer;
            }

        }

        .user-box-menu {
            font-size: 36px;
            padding: 0 15px;
        }

    }


}

.draw-menu-box {

    .draw-menu-box-item {
        height: 60px;
        position: relative;
        font-family: 思源黑体;
        font-size: 15px;
        font-weight: normal;
        line-height: normal;
        letter-spacing: 0em;
        color: #333;

        &:hover {
            cursor: pointer;
        }
    }

    .draw-menu-box-acvited {
        color: #0AA26B;

        &::before {
            content: "";
            display: inline-block;
            position: absolute;
            width: 59px;
            height: 4px;
            background: #0AA26B;
            top: 30px;
        }
    }

}
</style>